module.exports = __webpack_public_path__ + "static/scale-model-of-cry-baby-hill-in-tulsa-oklahoma-c63d130cb34dbb4ced79ebadd668b55a.png";